export default __webpack_public_path__ + "static/media/4.f19095c2.jpg";